<!-- Main Page Start -->
<div class="content-wrapper table-full-bx search-candidates">
    <div class="page-content recruiterpanel">
        <div class="row">
            <!-- Active users -->
            <div class="col-lg-12">
                <div class="ibox">
                    <div class="ibox-body">
                        <!-- Checkbox -->

                        <!-- searchbox -->
                        <div class="flexbox">
                            <div class="iboxcontent ">
                                <h3 class="mb-2"> Search Candidates</h3>
                            </div>
                        </div>
                        <!-- end -->

                        <form>
                            <div class="row">
                                <div class="col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label> Keyword or boolean search </label>
                                        <!-- <input type="text" class="form-control" placeholder="Guard, Cook, Security supervisor" [(ngModel)]="search" name="search" title="Enter search keyword"> -->
                                        <input (ngModelChange)="onTextChange($event)" class="form-control" type="text"
                                            [(ngModel)]="search" placeholder="Please enter the skills or job title"
                                            title="Enter search keyword" autocomplete="off" id="search" name="search">
                                        <div class="text-danger" *ngIf="showError == true">Press enter search keyword.
                                        </div>
                                        <div class="dropdown-menu search-dropdown searchRecruiterPannel"
                                            [ngClass]="allJobs?.length > 0 ? 'show':''" id="autoSearch" #autoSearch>
                                            <ul class="dropdown">
                                                <li *ngFor="let item of allJobs">
                                                    <a class="dropdown-item" data-toggle="modal"
                                                        (click)="setSearchText(item)"> {{item?._source.name ||
                                                        item?._source.searchKey}}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <div class="form-group">
                                        <label> Location </label>
                                        <input type="text" class="form-control" [(ngModel)]="location" name="location"
                                            placeholder="State or Zip Code">
                                        <div class="text-danger" *ngIf="showLocationError == true">Please enter location
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <div class="form-group">
                                        <label> Distance </label>
                                        <input type="text" class="form-control" [(ngModel)]="distance" name="distance"
                                            placeholder="30 miles" (keypress)="preventNumbers($event)">
                                        <div class="text-danger" *ngIf="showDistanceError == true">Please enter Distance
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-2">
                                    <div class="saved-search-wrap">
                                        <a href="javascript:void(0);" class="saved-searches"
                                            routerLink="/search/save-search"> Saved searches </a>
                                        <button type="button" title="" class="search-btn planbtn fill"
                                            (click)="searchFun()"> Search </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- More filters  -->
                <div class="ibox">
                    <div class="ibox-body">
                        <!-- Checkbox -->
                        <div class="row">
                            <div class="col-md-12 col-lg-4">
                                <div class="white-box">
                                    <form>
                                        <h4 class="filter-heading">More filters</h4>
                                        <div class="filter-heading button"> <button type="button"
                                                class="apply-btn planbtn fill" (click)="applyFilter()"
                                                [disabled]="!filterNotApplicable"> Apply </button> <a
                                                href="javascript:void(0);" class="clear-all" (click)="onClearFilters()">
                                                Clear all </a></div>
                                        <div class="text-danger" *ngIf="showErrorSubCategory == true">Press select
                                            sub-category.</div>
                                        <div id="accordion">
                                            <!-- 1 -->
                                            <div class="accordion-drawer">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title" for="accordion-drawer">Resume
                                                    Last Updated </label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content ">
                                                        <div class="form-group">
                                                            <label> Last Updated </label>
                                                            <select class="form-control"
                                                                (change)="selectedResumeUpdated($event)"
                                                                name="resumeLastUpdate"
                                                                [(ngModel)]="selectedFilters.resumeLastUpdate">
                                                                <option value="0"> All </option>
                                                                <option value="1"> Within 1 months </option>
                                                                <option value="2"> Within 3 months </option>
                                                                <option value="3"> Within 6 months </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 2 -->

                                            <div class="accordion-drawer">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer1"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title" for="accordion-drawer1"> Exclude
                                                    Candidates</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of Exclude_Candidate; let i = index;"
                                                                    class="col-lg-6">
                                                                    <div class="checkboxWrap">
                                                                        <input type="checkbox"
                                                                            (change)="onFilterOptionChange($event,option,'excludeCandidate')"
                                                                            id="excludeCandidate{{i}}"
                                                                            value="{{option.id}}"
                                                                            [checked]="toggleFilterChekbox(option.id,'excludeCandidate')" />
                                                                        <label for="excludeCandidate{{i}}">
                                                                            {{option.name}} </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Resume filters -->
                                        <h4 class="filter-heading"> Resume filters </h4>
                                        <div id="accordion">
                                           
                                            <!-- 4 -->
                                            <div class="accordion-drawer">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer3"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title" for="accordion-drawer3">Years of
                                                    Experience</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <label style="text-transform: none;"> Select Years of Experience </label>
                                                            <!-- <input type="text" class="form-control" (change)="onWorkExperiences($event)" name="workExperiences" [(ngModel)]="selectedFilters.workExperiences"> -->
                                                            <select class="form-control"
                                                                (change)="onWorkExperiences($event)"
                                                                name="workExperiences"
                                                                [(ngModel)]="selectedFilters.workExperiences">
                                                                <option disabled selected>Select Experience</option>
                                                                <option value="1">
                                                                    Less than 1 Year</option>
                                                                <option value="2">Less than 2 Years</option>
                                                                <option value="3">Less than 3 Years</option>
                                                                <option value="4">Less than 4 Years</option>
                                                                <option value="5">Less than 5 Years</option>
                                                                <option value="6">Less than 6 Years</option>
                                                                <option value="7">Less than 7 Years</option>
                                                                <option value="8">Less than 8 Years</option>
                                                                <option value="9">Less than 9 Years</option>
                                                                <option value="10">10+ Years</option>
                                                                <!-- <option value="10">10 or +10 Years</option> -->
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 5 -->

                                            <div class="accordion-drawer">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer4"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title"
                                                    for="accordion-drawer4">Company/Employer</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <label> Search Company/Employer</label>
                                                            <input type="text" class="form-control" class="form-control"
                                                                (change)="onCompanyName($event)" name="companyName"
                                                                [(ngModel)]="selectedFilters.companyName">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 8 -->

                                            <div class="accordion-drawer">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer7"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title"
                                                    for="accordion-drawer7">Salary</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <label>Amount </label>
                                                            <div class="amount">
                                                                <span>$</span>
                                                                <input type="text" class="form-control"
                                                                    (change)="onSalary($event)" name="salary"
                                                                    [(ngModel)]="selectedFilters.salary"
                                                                    (keypress)="preventNumbers($event)">
                                                            </div>
                                                        </div>
                                                        <div class="form-group mt-3">
                                                            <label>Rate </label>
                                                            <select class="form-control" (change)="onSalaryRate($event)"
                                                                name="rate" [(ngModel)]="selectedFilters.rate">
                                                                <option selected disabled [value]=null>Select Rate
                                                                </option>
                                                                <option value="Per Hour">Per Hour</option>
                                                                <option value="Per Day">Per Day</option>
                                                                <option value="Per Week">Per Week</option>
                                                                <option value="Per Month">Per Month</option>
                                                                <option value="Per Annum">Per Annum</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <h4 class="filter-heading">Profile Search Filters</h4>
                                        <div id="accordion">
                                            <!-- 6 -->

                                            <div class="accordion-drawer" *ngIf="showVaternStatus">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer5"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title" for="accordion-drawer5">Veteran
                                                    Status</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of filterOptions?.vaternStatus; let i = index;"
                                                                    class="col-lg-12">
                                                                    <div class="checkboxWrap" *ngIf="option?.count > 0">
                                                                        <input type="checkbox"
                                                                            (change)="onFilterOptionChange($event,option,'vaternStatus')"
                                                                            id="vaternStatus{{i}}" value="{{option.id}}"
                                                                            [checked]="toggleFilterChekbox(option.id,'vaternStatus')" />
                                                                        <label for="vaternStatus{{i}}"> {{option.name}} ({{option.count || 0}})
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                             <!-- 3 -->
                                             <div class="accordion-drawer" *ngIf="skillData?.length">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer2"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title"
                                                    for="accordion-drawer2">Skills</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="infinite-scroll onSearchScrollFilter" id="style-1" infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onModalScrollDown()">
                                                            <div class="row">
                                                                <div *ngFor="let skill of skillData; let i = index;"
                                                                    class="col-lg-12">
                                                                    <div class="checkboxWrap">
                                                                        <input type="checkbox"
                                                                            (change)="onFilterOptionChange($event,skill,'skillId')"
                                                                            id="skillId{{i}}" value="{{skill.id}}"
                                                                            [checked]="toggleFilterChekbox(skill.id,'skillId')" />
                                                                        <label for="skillId{{i}}"> {{skill.name}}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 7 -->
                                            <div class="accordion-drawer" *ngIf="filterOptions?.jobtitle.length">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer6"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title"
                                                    for="accordion-drawer6">Title</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="infinite-scroll onSearchScrollFilter" id="style-1" infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onModalScrollDown()">
                                                                <div class="row">
                                                                    <div *ngFor="let option of filterOptions?.jobtitle; let i = index;"
                                                                        class="col-lg-12">
                                                                        <div class="checkboxWrap">
                                                                            <input type="checkbox"
                                                                                (change)="onFilterOptionChange($event,option,'jobTitleId')"
                                                                                id="jobtitle{{i}}" value="{{option.id}}"
                                                                                [checked]="toggleFilterChekbox(option.id,'jobTitleId')" />
                                                                            <label for="jobtitle{{i}}"> {{option.name}}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            

                                            <!-- 9 -->

                                            <div class="accordion-drawer" *ngIf="filterOptions?.category.length">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer8"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title"
                                                    for="accordion-drawer8">Category</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of filterOptions?.category; let i = index;"
                                                                    class="col-lg-12">
                                                                    <div class="checkboxWrap">
                                                                        <input type="checkbox"
                                                                            (change)="onFilterOptionChange($event,option,'categoryId')"
                                                                            id="category{{i}}" value="{{option.id}}"
                                                                            [checked]="toggleFilterChekbox(option.id,'categoryId')" />
                                                                        <label for="category{{i}}"> {{option.name}}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 10 -->

                                            <div class="accordion-drawer" *ngIf="showSubCategory">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer8a"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title" for="accordion-drawer8a">Sub
                                                    Category</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of subCategory; let i = index;"
                                                                    class="col-lg-12">
                                                                    <div class="checkboxWrap">
                                                                        <input type="checkbox"
                                                                            (change)="onFilterOptionChange($event,option,'specializationId')"
                                                                            id="specializatio{{i}}"
                                                                            value="{{option.id}}"
                                                                            [checked]="toggleFilterChekbox(option.id,'specializationId')" />
                                                                        <label for="specializatio{{i}}"> {{option.name}}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 10 -->

                                            <div class="accordion-drawer"  *ngIf="filterOptions?.travelRequirement.length">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer9"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title" for="accordion-drawer9">Travel
                                                    Requirements</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of filterOptions?.travelRequirement; let i = index;"
                                                                    class="col-lg-12">
                                                                    <div class="checkboxWrap">
                                                                        <input type="checkbox"
                                                                            (change)="onFilterOptionChange($event,option,'travelRequirementId')"
                                                                            id="travelRequirement{{i}}"
                                                                            value="{{option.id}}"
                                                                            [checked]="toggleFilterChekbox(option.id,'travelRequirementId')" />
                                                                        <label for="travelRequirement{{i}}">
                                                                            {{option.name}} </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 11 -->
                                            <div class="accordion-drawer"  *ngIf="filterOptions?.workPlace.length">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer10"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title" for="accordion-drawer10">Work
                                                    place</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of filterOptions?.workPlace; let i = index;"
                                                                    class="col-lg-6">
                                                                    <div class="checkboxWrap">
                                                                        <input type="checkbox"
                                                                        (change)="onFilterOptionChange($event,option,'workPlace')"
                                                                        id="{{option.key}}" value="{{option.key}}"
                                                                        [checked]="toggleFilterChekbox(option.key,'workPlace')" />
                                                                    <label for="{{option.key}}"> {{option.key +'('+option.doc_count+')'}}
                                                                    </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 12 -->

                                            <div class="accordion-drawer" *ngIf="willingToRelocateCount.yes >0 || willingToRelocateCount.no >0">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer11"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title" for="accordion-drawer11">Willing
                                                    to relocate</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div class="col-lg-6" *ngIf="willingToRelocateCount.yes>0">
                                                                    <div class="radioWrap"><input type="radio" id="Yes"
                                                                            (change)="onWillingToRelocate($event)"
                                                                            name="willingToRelocate" value="1"
                                                                            [(ngModel)]="selectedFilters.willingToRelocate" /><label
                                                                            for="Yes"> Yes ({{willingToRelocateCount.yes}}) </label></div>
                                                                </div>
                                                                <div class="col-lg-6" *ngIf="willingToRelocateCount.no>0">
                                                                    <div class="radioWrap"><input type="radio" id="No"
                                                                            (change)="onWillingToRelocate($event)"
                                                                            name="willingToRelocate" value="0"
                                                                            [(ngModel)]="selectedFilters.willingToRelocate" />
                                                                        <label for="No"> No  ({{willingToRelocateCount.no}})</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 13 -->
                                            <div class="accordion-drawer"  *ngIf="filterOptions?.securityClearance.length">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer12"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title" for="accordion-drawer12">Security
                                                    Clearance</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of filterOptions?.securityClearance; let i = index;"
                                                                    class="col-lg-12">
                                                                    <div class="checkboxWrap">
                                                                        <input type="checkbox"
                                                                            (change)="onFilterOptionChange($event,option,'securityClearanceId')"
                                                                            id="securityClearance{{i}}"
                                                                            value="{{option.id}}"
                                                                            [checked]="toggleFilterChekbox(option.id,'securityClearanceId')" />
                                                                        <label for="securityClearance{{i}}">
                                                                            {{option.name}} </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 14 -->
                                            <div class="accordion-drawer">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer13"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title"
                                                    for="accordion-drawer13">Availability</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div class="col-lg-12">
                                                                    <div class="checkboxWrap"><input type="checkbox"
                                                                            id="Immediately"
                                                                            (change)="onAvailability($event)"
                                                                            name="availability" value="1"
                                                                            [(ngModel)]="selectedFilters.availability" /><label
                                                                            for="Immediately"> Available Immediately
                                                                        </label></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 15 -->

                                            <div class="accordion-drawer"   *ngIf="filterOptions?.employmentTypes.length">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer14"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title"
                                                    for="accordion-drawer14">Employment Type</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of filterOptions?.employmentTypes; let i = index;"
                                                                    class="col-lg-6">
                                                                    <div class="checkboxWrap">
                                                                        <input type="checkbox"
                                                                            (change)="onFilterOptionChange($event,option,'employementTypeId')"
                                                                            id="employmentTypes{{i}}"
                                                                            value="{{option.id}}"
                                                                            [checked]="toggleFilterChekbox(option.id,'employementTypeId')" />
                                                                        <label for="employmentTypes{{i}}">
                                                                            {{option.name}} ({{option.count || 0}}) </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 16 -->

                                            <div class="accordion-drawer" hidden>
                                                <input class="accordion-drawer__trigger" id="accordion-drawer15"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title"
                                                    for="accordion-drawer15">Candidate Relation</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <label> Last Updated </label>
                                                            <select class="form-control">
                                                                <option> Within 3 months </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 17 -->
                                            <div class="accordion-drawer" *ngIf="filterOptions?.education.length">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer16"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title"
                                                    for="accordion-drawer16">Education</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of filterOptions?.education; let i = index;"
                                                                    class="col-lg-12">
                                                                    <div class="checkboxWrap">
                                                                        <input type="checkbox"
                                                                            (change)="onFilterOptionChange($event, option,'education')"
                                                                            id="specializationsOrEducation{{i}}"
                                                                            value="{{option.key}}"
                                                                            [checked]="toggleFilterChekbox(option.key,'education')" />
                                                                        <label for="specializationsOrEducation{{i}}">
                                                                            {{option.key}} ({{option.doc_count || 0}}) </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 18 -->
                                            <div class="accordion-drawer" *ngIf="filterOptions?.Languages.length">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer17"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title"
                                                    for="accordion-drawer17">Languages known</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of filterOptions?.Languages; let i = index;"
                                                                    class="col-lg-6">
                                                                    <div class="checkboxWrap">
                                                                        <input type="checkbox"
                                                                            (change)="onFilterOptionChange($event, option,'language')"
                                                                            id="language{{i}}"
                                                                            value="{{option.key}}"
                                                                            [checked]="toggleFilterChekbox(option.key,'language')" />
                                                                        <label for="language{{i}}">
                                                                            {{option.key}} ({{option.doc_count || 0}}) </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 19 -->
                                            <div class="accordion-drawer" *ngIf="filterOptions?.industry.length">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer18"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title"
                                                    for="accordion-drawer18">Industry</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of filterOptions?.industry; let i = index;"
                                                                    class="col-lg-6">
                                                                    <div class="checkboxWrap">
                                                                        <input type="checkbox"
                                                                            (change)="onFilterOptionChange($event,option,'industryName')"
                                                                            id="industry{{i}}" value="{{option.id}}"
                                                                            [checked]="toggleFilterChekbox(option.id,'industryName')" />
                                                                        <label for="industry{{i}}"> {{option.name}}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 20 -->
                                            <div class="accordion-drawer" *ngIf="showPersonalities">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer19"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title" for="accordion-drawer19">Personalities</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of filterPersonalityOptions; let i = index;">
                                                                    <div class="col-lg-12" *ngIf="option.count>0">
                                                                        <div class="checkboxWrap">
                                                                            <input type="checkbox"
                                                                                (change)="onFilterOptionChange($event,option,'personalityTest')"
                                                                                id="personalityTest{{i}}"
                                                                                value="{{option.title}}"
                                                                                [checked]="toggleFilterChekbox(option.title,'personalityTest')" />
                                                                            <label for="personalityTest{{i}}"> {{option.title}} ({{option.count || 0 }})
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 21 -->

                                            <div class="accordion-drawer" *ngIf="showWorkAuthorizationOptions">
                                                <input class="accordion-drawer__trigger" id="accordion-drawer21"
                                                    type="checkbox" />
                                                <label class="accordion-drawer__title" for="accordion-drawer21">Work
                                                    Authorization</label>
                                                <div class="accordion-drawer__content-wrapper">
                                                    <div class="accordion-drawer__content">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div *ngFor="let option of workAuthorizationOptions; let i = index;">
                                                                    <div class="col-lg-12" *ngIf="option.count>0">
                                                                        <div class="checkboxWrap">
                                                                            <input type="checkbox"
                                                                                (change)="onFilterOptionChange($event,option,'workAuthorization')"
                                                                                id="workAuthorization{{i}}"
                                                                                value="{{option.name}}"
                                                                                [checked]="toggleFilterChekbox(option.name,'workAuthorization')" />
                                                                            <label for="workAuthorization{{i}}"> {{option.name}} ({{option.count || 0 }})
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                   <!-- <div class="radioWrap"><input type="checkbox" id="{{option.key}}"
                                                                        (change)="onWorkAuthorization($event, option.key)"
                                                                        name="workAuthorization" value="{{option.key}}"
                                                                        [(ngModel)]="selectedFilters.workAuthorization" /><label
                                                                        for="{{option.key}}">{{option.name}} ({{option?.count || 0}})</label></div> -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        
                                        <button type="button" class="apply-btn planbtn fill" (click)="applyFilter()"
                                            [disabled]="!filterNotApplicable"> Apply </button>
                                        <div class="text-danger" *ngIf="showErrorSubCategory == true">Press select
                                            sub-category.</div>
                                    </form>
                                </div>
                            </div>
                            <!-- right Panel  -->
                            <div class="col-md-12 col-lg-8">
                                <div class="search-results" *ngIf="resultData.length == 0">
                                    <div class="no-results">
                                        <img src="../../../assets/images/ic_serech_empty.svg" />
                                        <h6>Your search results would be displayed here</h6>
                                        <p>Select relevant filters and hit search to view search results</p>
                                    </div>
                                </div>
                                <div class="result" *ngIf="resultData.length > 0">
                                    <div class="total-number">
                                        <p> <img src="../../../assets/images/ic_marked_done.svg" >
                                            {{totalresultDataCount}} / {{totalresultDataCount}} <img
                                                src="../../../assets/images/info.svg"> </p>
                                    </div>

                                    <div class="specialist-row">
                                        <p class="align"><strong> {{totalresultDataCount}} </strong> <span>Profiles
                                                found for</span>
                                            <strong> {{resultSkill || "-"}} </strong>
                                        </p>
                                        <a href="javascript:void(0);" class="save-search-btn"
                                            (click)="onSaveSearch($event,totalresultDataCount )"> Save Search </a>
                                    </div>
                                    <!-- <div class="infinite-scroll onSearchScroll" id="style-1" infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onModalScrollDown()"> -->
                                    <div class="cardWrap"
                                        *ngFor="let data of resultData | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index;">
                                        <div class="col-bx-top" (click)="goToDetail(data?._source?.id)"
                                            style="cursor: pointer;">
                                            <div class="user-pic">
                                                <img
                                                    [src]="data?._source?.profilePic != null ? globalUrl + data?._source?.profilePic : 'assets/images/profile-img.jpg'">
                                            </div>
                                            <div class="listview">
                                                <div class=" user-details">
                                                    <div class="user-info">
                                                        <h6 class="user-name cap">{{data?._source?.name}}<span>
                                                                <!-- ({{totalExperience(data)}}) -->
                                                                ({{data?._source?.yearsOfExperienceInYear > 1 ?
                                                                data?._source?.yearsOfExperienceInYear +"
                                                                years":data?._source?.yearsOfExperienceInYear+" year"}})
                                                            </span> <span class="match"> 99% Match </span></h6>
                                                        <span class="user-loc"><img
                                                                src="../../../assets/images/ic_location.svg">
                                                            {{data?._source?.location}}</span>
                                                    </div>
                                                </div>

                                                <!-- <div *ngFor="let wrk of data.user_work_experiences"> -->
                                                <dl *ngIf="data?._source?.prferredJobLocation != null">
                                                    <dt>Preferred Location</dt>
                                                    <dt>
                                                        <p *ngFor="let location of data?._source?.prferredJobLocation">
                                                            {{location.location}}</p>
                                                    </dt>
                                                </dl>
                                                <dl *ngIf="data?.currentWork != null">
                                                    <dt> Current</dt>
                                                    <dt>
                                                        <p> {{data.currentWork?.jobtitle}} at
                                                            {{data.currentWork?.companyName}} <strong>
                                                                {{data.currentWork?.fromDate | date:
                                                                "yyy"}}-{{data.currentWork?.isCurrentlyRole == 1 ?
                                                                "Present": data.currentWork?.toDate | date: "yyy"}}
                                                            </strong></p>
                                                    </dt>
                                                </dl>
                                                <dl *ngIf="data?.pastWork?.length != 0">
                                                    <dt> Past</dt>

                                                    <dt>
                                                        <p *ngFor="let wrk of data?.pastWork"> {{wrk?.jobtitle}} at
                                                            {{wrk?.companyName}} <strong> {{wrk.fromDate | date:
                                                                "yyy"}}-{{wrk.toDate | date: "yyy"}} </strong></p>
                                                    </dt>
                                                </dl>
                                                <!-- </div> -->

                                                <dl>
                                                    <dt> Education</dt>
                                                    <dt>
                                                        <p *ngFor="let edu of data?._source?.education"> {{edu?.degree||
                                                            edu?.specialization}} from {{edu?.university}} <strong>
                                                                {{edu?.fromDate | date: "yyy"}}-{{edu?.toDate | date:
                                                                "yyy"}} </strong></p>
                                                    </dt>
                                                </dl>

                                                <dl>
                                                    <dt> Keyskills</dt>
                                                    <dt> <span class="com-btn"
                                                            *ngFor="let skill of data?._source?.skills; let i=index;">
                                                            {{skill?.name || "-"}} </span>
                                                    </dt>
                                                </dl>
                                            </div>
                                        </div>
                                        <div class="activity-box">
                                            <span class="activity-date"> <strong> Last activity </strong> -
                                                {{data?._source?.lastActivity | date: "d/M/YYYY"}} </span>
                                            <div class="activity-links">
                                                <a href="javascript:void(0)" (click)="open(sendMail,data?._source)" title="Send Mail"><img
                                                        src="../../../assets/images/ic_email.png" alt="Email"></a>
                                                <!-- (click)="mailMe()" -->
                                                <!-- (click)="openChatView(jobList,data)" -->
                                                <a href="javascript:void(0)" (click)="openChatJobView(jobList,data)"  title="Chat"><img
                                                        src="../../../assets/images/ic_message.png" alt="Message"></a>
                                                <!-- fav -->
                                                <!-- <a href="javascript:void(0)" (click)="addFav($event,0,data?._source?.id)" *ngIf="data?.isFavourite == null || data.isFavourite == 0"><img src="../../../assets/images/ic_star.svg" alt="Message"></a>
                                                <a href="javascript:void(0)" (click)="addFav($event,1,data?._source?.id)" *ngIf="data?.isFavourite == 1"><img src="../../../assets/images/ic_favourite_filed.svg" alt="Message"></a> -->
                                                <!-- downloadUser -->
                                                <a href="javascript:void(0)"
                                                    (click)="onDownlaod(data?._source?.id)" title="Download"><img
                                                        src="../../../assets/images/ic_download.png" alt="Download"></a>

                                                <a href="javascript:void(0)"
                                                    (click)="noteStatus($event,data?._source,addMore)" title="Notes"><img
                                                        src="../../../assets/images/ic_file.png" alt="File"></a>

                                                <a href="javascript:void(0)" class="share"
                                                    (click)="openModal(forwordMail,data?._source)" title="Share">
                                                    <img src="../../../assets/images/ic_share.png" alt="Share">
                                                    <!-- <div class="socialIcon">
                                                        <app-share-button type="facebook" [shareUrl]="link"> </app-share-button>  
                                                        <app-share-button type="linkedin" [shareUrl]="link"> </app-share-button>
                                                     </div> -->
                                                </a>

                                                <a href="javascript:void(0)"
                                                    (click)="hideUser(data?._source?.id, i)" title="Hide"><img
                                                        src="../../../assets/images/ic_close.png" alt="Close"></a>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- </div> -->
                                </div>
                                <div class="col-sm-12 p-0" *ngIf="totalresultDataCount > 3">
                                    <ul class="pagination ">
                                        <pagination-controls id="pagination" (pageChange)="pageChanged($event)"
                                            previousText="&#60;" nextText="Next" firstText="&#62;"
                                            lastText="Last"></pagination-controls>
                                    </ul>
                                </div>
                            </div>

                        </div>

                        <!-- end -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- job list -->

<ng-template #jobList>
    <div class="modal-body addModal text-left chatTable"> 
        <h4 class="pageTitle">Job List</h4>
        <div class="table-wrapper table-scroll table-responsive mt-3">
            <table id="example" class="table table-hover m-0 table-bordered" style="width:100%;">

                <thead>
                    <tr>
                        <th>Job Id </th>
                        <th>Job title</th>
                        <th>Post Date</th>
                        <th>User </th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    <!-- 1 -->
                    <tr
                        *ngFor="let jobData of allJobsList | paginate: { id:'paginationList', itemsPerPage: paginationList.limit, currentPage: currentPagejobList ,totalItems: paginationList.totalItems};let i=index"> 
                        <td><a href="javascript:void(0);" class="jobid"> <div class="checkBox_set"><label class="checkbox leftlabel">
                            <input type="checkbox" (change)="userSelect($event,i)"
                                [(ngModel)]="jobData.IsSelete"><i class="input-helper"></i>
                        </label>
                    </div> {{jobData.newId}}</a></td>
                        <td><a href="javascript:void(0);" >{{jobData.jobTitle}}</a></td>
                        <td><a href="javascript:void(0);" >{{jobData.createdAt | date:
                                "d/M/YYYY"}}</a></td>
                        <td><a href="javascript:void(0);" >
                                <span *ngIf="jobData.userType=='SUPER_RECRUITER'"
                                    style="display: inline;">{{jobData?.recruiterName}}</span>
                                <span *ngIf="jobData.userType=='SUB_RECRUITER'"
                                    style="display: inline;">{{jobData?.subRecruiterName}}</span>
                            </a></td> 
                        <td>
                            <a href="javascriot:void(0);">
                                <span class="green"
                                        *ngIf="jobData?.isBlocked == 0 && jobData?.isConfirm == 1">Open</span>
                                <span class="red"
                                        *ngIf="jobData?.isBlocked == 1  && jobData?.isConfirm == 1">Closed</span>
                                <span class="red" *ngIf="jobData?.isConfirm == 0">Draft</span>
                            </a>
                        </td> 
                    </tr>
                </tbody>
            </table>

            <div class="noDataFound" *ngIf="allJobsList == 0">
                <h2>No records found</h2>
            </div>
        </div> 
        <div class="col-sm-12 p-0" *ngIf="totalJobCount > 0">
            <ul class="pagination ">
                <pagination-controls id="paginationList" (pageChange)="pageChangedList($event)"
                    previousText="&#60;" nextText="Next" firstText="&#62;"
                    lastText="Last"></pagination-controls>
            </ul>
        </div>
    </div>
</ng-template>
<!-- job list end -->
<ng-template #addMore>
    <div class="modal-body addModal text-left">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <h4 class="pageTitle">Create note for {{noteData?.userName || noteData?.name}}</h4>
            <div class="form-group">
                <label> Status : </label>
                <select class="form-control" formControlName="status">
                    <option value="0"> Pending</option>
                    <option value="1"> Shortlist</option>
                    <option value="2"> Rejected</option>
                    <option value="3"> On Hold</option>
                    <option value="4">BV not cleared</option>
                    <option value="5">Hired</option>
                </select>
            </div>
            <div class="form-group">
                <label>Note</label>
                <textarea class="form-control" placeholder="Enter Note here..." formControlName="note"
                    maxlength="2000"></textarea>
                <p class="para5 text-left m-0">{{form?.value?.note?.length}}/2000</p>
            </div>
            <div class="d-flex">

                <div class="form-group">
                    <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a>
                </div>
                <div class="form-group">
                    <input type="submit" value="Save" class="planbtn fill">
                </div>

            </div>
        </form>
    </div>
</ng-template>

<ng-template #sendMail>
    <div class="modal-body addModal text-left">
        <form class="mailTemplate" [formGroup]="mailSendForm" (ngSubmit)="onSendMail()">
            <h4 class="pageTitle upper">Email Candidate</h4>
            <div class="form-group">
                <div class="d-flex">
                    <label>To:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="toEmail">
                    <div class="text-danger" *ngIf="mailSendForm.controls['toEmail'].hasError('required') && showError">
                        *Please Enter To address.
                    </div>
                    <div class="text-danger" *ngIf="mailSendForm.controls['toEmail'].hasError('pattern') && showError">
                      *Please enter valid email.
                    </div> 
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex">
                    <label>Subject:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="subject">
                    <div class="text-danger" *ngIf="mailSendForm.controls['subject'].hasError('required') && showError">
                        *Please Enter subject.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex">
                    <label>Template:</label>
                    <select class="form-control" (change)="onTemplateTypeSelect($event)">
                        <option selected disabled>Please select</option>
                        <option value="-1">None</option>
                        <option *ngFor="let tem of templateData; let i=index" [value]="i">{{tem.actionType}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group">
                <textarea class="form-control pdding-10" placeholder="Please write here" maxlength="2000"
                    formControlName="message"></textarea>
                <div class="text-danger" *ngIf="mailSendForm.controls['message'].hasError('required') && showError">
                    *Please Enter Template.
                </div>
            </div>
            <div class="text-right">
                <div class="form-group text-right">
                    <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a>
                    <input type="submit" value="Send" class="planbtn fill">
                </div>

            </div>

            <div class="instruction">
                <h5><img src="../../../../assets/images/info-circle.svg" alt="info-circle"> The following place holders
                    are allowed:</h5>
                <ul>
                    <li>
                        • &#10100;&#10100;USERNAME&#10101;&#10101; - Username for whom the mail will be sent
                    </li>
                    <li>
                        • &#10100;&#10100;USERFULLNAME&#10101;&#10101; - Sender’s full name
                    </li>
                    <li>
                        • &#10100;&#10100;MYEMAIL&#10101;&#10101; - Sender’s email address
                    </li>
                    <li>
                        • &#10100;&#10100;EMAIL&#10101;&#10101; - Recipient’s email address
                    </li>
                    <li>
                        • &#10100;&#10100;ORGANIZATIONNAME&#10101;&#10101; - Organization Name for which the Action is
                        performed
                    </li>
                </ul>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #forwordMail>
    <div class="modal-body addModal text-left">
        <form class="mailTemplate" [formGroup]="mailForwardForm" (ngSubmit)="onForwardMail()">
            <h4 class="pageTitle upper">Forward Candidate ({{userName}})</h4>
            <div class="form-group">
                <div class="d-flex">
                    <label>To:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="toEmail">
                    <div class="text-danger"
                        *ngIf="mailForwardForm.controls['toEmail'].hasError('required') && showError">
                        *Please Enter To address.
                    </div>
                    <div class="text-danger" *ngIf="mailForwardForm.controls['toEmail'].hasError('pattern') && showError">
                      *Please enter valid email.
                    </div> 
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex">
                    <label>Job Title:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="jobTitle">
                    <div class="text-danger"
                        *ngIf="mailForwardForm.controls['jobTitle'].hasError('required') && showError">
                        *Please Enter job title.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex">
                    <label>Subject:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="subject">
                    <div class="text-danger"
                        *ngIf="mailForwardForm.controls['subject'].hasError('required') && showError">
                        *Please Enter subject.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex">
                    <label>Candidates:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="candidate">
                    <div class="text-danger"
                        *ngIf="mailForwardForm.controls['candidate'].hasError('required') && showError">
                        *Please Enter candidate name.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <textarea class="form-control pdding-10" placeholder="Please write here" maxlength="2000"
                    formControlName="message"></textarea>
                <div class="text-danger" *ngIf="mailForwardForm.controls['message'].hasError('required') && showError">
                    *Please Enter message.
                </div>
            </div>
            <div class="text-right">
                <div class="form-group text-right">
                    <div class="buttonWrap">
                        <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a>
                        <input type="submit" value="Forward Candidate" class="planbtn fill largeBtn">
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>